import { styled } from "styled-components";
import { motion } from "framer-motion";

import HomeHeading from "../../components/HomeHeading";
import HomeContainerWrapper from "../../components/HomeContainerWrapper";
import Profile from "../../components/Profile";

const revealTransition = {
  duration: 0.72,
  ease: [0.22, 1, 0.36, 1],
};

export default function index() {
  return (
    <Container
      className="wrap"
      id="contact"
      initial={{ opacity: 0, y: 34 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.22 }}
      transition={revealTransition}
    >
      <HomeContainerWrapper>
        <HomeHeading>Let's Talk</HomeHeading>
        <div className="contact-wrapper">
          <div className="talk">
            <p>
              <span
                style={{
                  display: "block",
                  fontSize: "60px",
                  marginBottom: "50px",
                }}
              >
                👋
              </span>
              Got a question or just want to chat? Reach out to me - I can't
              wait to hear from you!
            </p>
            <motion.a
              whileHover={{ scale: 1.1 }}
              transition={{ type: "spring", stiffness: 400, damping: 8 }}
              href="mailto:its.sivasanker@gmail.com"
            >
              Say Hello
            </motion.a>
          </div>
        </div>
        <Profile />
      </HomeContainerWrapper>
    </Container>
  );
}

const Container = styled(motion.div)`
  margin-top: 120px;
  width: 100%;
  font-family: "Poppins", sans-serif;

  .contact-wrapper {
    width: 100%;

    .talk {
      width: 100%;
      display: flex;
      align-items: flex-end;

      p {
        max-width: 560px;
        width: 100%;
        padding-right: 20px;
        user-select: none;
        font-weight: 300;
        font-size: 18px;
        color: #abababff;
        line-height: 2em;
      }

      a {
        user-select: none;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        color: #abababff;
        text-decoration: none;
        width: fit-content;
        font-weight: 300;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 15px;
        background: none;
        aspect-ratio: 1/1;
        flex-shrink: 0;
        border: 1px solid #abababff;
      }
    }
  }

  @media (max-width: 768px) {
    .talk {
      p {
        font-size: 13px !important;
      }

      p span {
        font-size: 40px !important;
      }

      a {
        font-size: 11px !important;
      }
    }
  }
`;
